import React, { useEffect, useState } from "react";
import { TasksStepProps } from "./TaskStep.types";
import {
  StepHeader,
  StepIcon,
  ChevronIcon,
  ProgressLine,
} from "./TaskStep.styles";
import FlexColumn from "../../../components/Layout/FlexColumn/FlexColumn";
import FlexRow from "../../../components/Layout/FlexRow/FlexRow";
import {
  Body5MediumTypography,
  Body6RegularTypography,
} from "../../../primitives/Typography/typographyVariants";
import { colorPalette } from "../../../theme/colors";
import { Icon } from "../../../components/Icon/Icon";
import Box from "../../../primitives/Box/Box";

export const TasksStep: React.FC<TasksStepProps> = ({
  title,
  subtitle,
  icon,
  isActive,
  isLast = false,
  children,
  isOpen = false,
  onToggle,
  dataCy = "tasks-step",
  defaultExpanded = false,
}) => {
  const [internalIsOpen, setInternalIsOpen] = useState(defaultExpanded);

  // Use external isOpen if provided, otherwise use internal state
  const isExpanded = isOpen !== undefined ? isOpen : internalIsOpen;

  useEffect(() => {
    if (defaultExpanded) {
      setInternalIsOpen(true);
    }
  }, [defaultExpanded]);
  const handleToggle = () => {
    if (isActive) {
      if (onToggle) {
        onToggle();
      } else {
        setInternalIsOpen(!internalIsOpen);
      }
    }
  };

  return (
    <FlexColumn data-cy={dataCy} position="relative" gap={0}>
      <StepHeader isActive={isActive}>
        <FlexColumn width="unset" alignItems="center" justifyContent="center">
          <StepIcon isActive={isActive}>
            <Icon
              name={icon}
              height="12"
              width="12"
              size="10"
              color={colorPalette.popWhite[500]}
            />
          </StepIcon>
          {!isLast && <ProgressLine isActive={isActive} isLast={isLast} />}
        </FlexColumn>

        <FlexColumn gap={4} pb={16} flex={1}>
          <FlexRow flex={1}>
            <Body5MediumTypography>{title}</Body5MediumTypography>
            <ChevronIcon
              isOpen={isOpen}
              className="fa-solid fa-chevron-down"
              onClick={handleToggle}
              data-cy={`${dataCy}-chevron`}
            />
          </FlexRow>
          {subtitle && (
            <Body6RegularTypography color={colorPalette.popBlack[100]}>
              {subtitle}
            </Body6RegularTypography>
          )}
          {isOpen && children && <Box width="100%">{children}</Box>}
        </FlexColumn>
      </StepHeader>
    </FlexColumn>
  );
};
